module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"autoconvertHint":"Автоконверт на счет {account}"},"en":{"autoconvertHint":"Autoconvert to account {account}","Поиск...":"Search...","Ничего не найдено":"Nothing found","Выберите":"Please select","Выберите счет":"Please select account","Выберите адрес":"Please select address","Адрес генерируется...":"Address is generating..."}}')
  delete Component.options._Ctor
}
